import React from 'react';
import styles from './Subscriber.module.css';

const Subscriber = ({ endDate, beginDate }) => {
    const formattedEndDate = endDate
        ? new Date(endDate).toLocaleDateString('fr-FR')
        : '';

    const formattedBeginDate = beginDate
        ? new Date(beginDate).toLocaleDateString('fr-FR')
        : '';

    return (
        <div>
            <div className={styles.card}>
                <img className={styles.logo} src='/Subscription/checkout.png' alt=''/>
                <h1 className={styles.title}>BIENVENUE CHEZ DEALYGO !!!</h1>
                <div className={styles.list}>
                    <li className={styles.option}>✔️ Mise en avant et référencement sur notre site</li>
                    <li className={styles.option}>✔️ Visibilité sur nos réseaux sociaux</li>
                    <li className={styles.option}>✔️ Diffusion de vos offres</li>
                </div>
                <h2 className={styles.subtitle}>Abonnement valable du<br></br><strong>{formattedBeginDate}</strong> au <strong>{formattedEndDate}</strong></h2>
            </div>
        </div>
    );
};

export default Subscriber;